import { Serializable } from "../utilities/Serializable";

export class PosAppVersion extends Serializable {
    uuid: string;
    version: string;
    link: string;
    message: string;
    minAllowedVersion: string;
    minAllowedVersionExpiration: Date;

    constructor() {
        super();
    }

}



// WEBPACK FOOTER //
// ./src/app/models/PosAppVersion.ts